export function imgPath(img: string) {
  return `img/${img}?${BuildId}`;
}

export function imgUrl(img: string) {
  const path = imgPath(img);
  return `url(${path})`;
}
